module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/naina-31db2d1eb01bd1b260cfed01378e287c.mp3";